// src/stores/ui.js
import { defineStore } from "pinia";

export const useUIStore = defineStore("ui", {
  state: () => ({
    drawer: true, // visible by default on desktop
    rail: false, // collapsed‐rail mode off by default
  }),
  actions: {
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    toggleRail() {
      this.rail = !this.rail;
    },
  },
});
